export default "__VITE_ASSET__CLZnMKpa__"